import React, { useState } from "react";
import { WalletCards, ArrowRight } from 'lucide-react';
import { createFlashcardSession } from "utils/supabase.js";
import { useHistory } from "react-router-dom";

import ButtonGroupNumPreguntas from "components/Custom/ButtonGroupNumPreguntas";
import RadioGroupModo from "components/Custom/RadioGroupModo";
import RadioGroupFlashcards from "components/Custom/RadioGroupFlashcards";
import CheckGroupMaterias from "components/Custom/CheckGroupMaterias";
import BackdropAlert from "components/Custom/BackdropAlert.js";

export default function Flashcards() {
    const history = useHistory();
    const [isStartButtonHovered, setIsStartButtonHovered] = useState(false);
    const [numFlashcards, setNumFlashcards] = useState(0);
    const [modo, setModo] = useState('materias');
    const [tipoFlashcards, setTipoFlashcards] = useState('due');
    const [materiasSeleccionadas, setMateriasSeleccionadas] = useState([]);
    const [backdropAlert, setBackdropAlert] = useState({
        open: false,
        severity: "info",
        title: "",
        message: "",
        description: "",
        closeOnBackdropClick: true,
        primaryAction: null,
        secondaryAction: null,
    });
    const accentColor = '#FE8C62';
    const accentHoverColor = '#f97316';
    const accentSoftBorder = '#ffd2c0';

    const closeBackdropAlert = () => {
        setBackdropAlert((prev) => ({ ...prev, open: false }));
    };

    const showBackdropAlert = ({
        severity = "info",
        title = "",
        message = "",
        description = "",
        closeOnBackdropClick = true,
        primaryAction = null,
        secondaryAction = null,
    }) => {
        setBackdropAlert({
            open: true,
            severity,
            title,
            message,
            description,
            closeOnBackdropClick,
            primaryAction,
            secondaryAction,
        });
    };

    const handleStartFlashcards = async () => {

        const {data, error} = await createFlashcardSession(
            materiasSeleccionadas,
            numFlashcards,
            tipoFlashcards
        );

        if (error) {
            console.error("Error creating flashcard session:", error);
            showBackdropAlert({
                severity: "error",
                title: "No se pudo crear la sesión",
                message: "No se pudo iniciar la sesión de flashcards.",
                description: error?.message || "Ocurrió un error inesperado.",
                primaryAction: {
                    label: "Cerrar",
                    onClick: closeBackdropAlert,
                },
            });
        } else {

            history.push(`/admin/flashcards/${data.flashcard_session_id}`);
        }

    };

  return (
    <>
    <div className="flex flex-wrap mt-100 items-stretch">
        <div className="w-full lg:w-12/12 px-4 bg-white shadow-md rounded-lg border border-[#ffd2c0] p-4 flex flex-col">
                <div className="w-full mb-4">
                    <h1 className="text-lg font-bold mb-2 flex items-center text-[#9a3412]">
                        <WalletCards size={24} color={accentColor} className="mr-2" />Flashcards ENARM
                    </h1>
                    <p className="text-xs mb-4" style={{ color: accentColor }}>
                        Configura tu sesion de flashcards a tu medida.
                    </p>
                </div>

                <div className="flex flex-col gap-4 md:flex-row">
                    <div className="w-full mb-6 xl:mb-0 flex flex-col md:w-12/12">
                    <RadioGroupFlashcards
                        value={tipoFlashcards}
                        onChange={setTipoFlashcards}
                        accentColor={accentColor}
                    />
                    </div>
                </div>

                <div className="flex flex-col gap-4 md:flex-row mt-6">
                    <div className="w-full mb-6 xl:mb-0 flex flex-col md:mr-4 md:w-6/12">
                    <ButtonGroupNumPreguntas
                        title="Numero de flashcards"
                        value={numFlashcards}
                        onChange={setNumFlashcards}
                        modo={modo}
                        options={[0, 10, 20, 30, 40, 50]}
                        accentColor={accentColor}
                        accentHoverColor={accentHoverColor}
                    />
                    </div>
                    <div className="w-full mb-6 xl:mb-0 flex flex-col md:w-6/12 md:mr-4">
                    <RadioGroupModo
                        value={modo}
                        onChange={setModo}
                        showAleatorioOption={false}
                        showEnarmOption={false}
                        showSoloCasosClinicosOption={false}
                        accentColor={accentColor}
                    />
                    </div>
                </div>

                <div className="flex flex-col gap-4 md:flex-row mt-6">
                    <div className="w-full mb-6 xl:mb-0 flex flex-col md:mr-4">
                    <CheckGroupMaterias
                        onChange={setMateriasSeleccionadas}
                        modo={modo}
                        defaultSelectAll
                        accentColor={accentColor}
                        accentBorderColor={accentSoftBorder}
                        accentHoverBgColor="#fff1eb"
                    />
                    </div>
                </div>

                <div className="flex flex-col gap-4 md:flex-row mt-6">
                    <div className="w-full mb-6 xl:mb-0 flex justify-end md:w-full md:mr-4">
                    <button
                        className="text-white text-sm px-4 py-3 rounded transition duration-300 inline-flex items-center justify-center gap-3 leading-none"
                        style={{
                            backgroundColor: isStartButtonHovered ? accentHoverColor : accentColor,
                        }}
                        onClick={handleStartFlashcards}
                        onMouseEnter={() => setIsStartButtonHovered(true)}
                        onMouseLeave={() => setIsStartButtonHovered(false)}
                    >
                        Iniciar sesión de flashcards
                        <ArrowRight size={16} className="ml-1" />
                    </button>
                    </div>
                </div>
        </div>
    </div>
    <BackdropAlert
        open={backdropAlert.open}
        onClose={closeBackdropAlert}
        severity={backdropAlert.severity}
        title={backdropAlert.title}
        message={backdropAlert.message}
        description={backdropAlert.description}
        closeOnBackdropClick={backdropAlert.closeOnBackdropClick}
        primaryAction={backdropAlert.primaryAction}
        secondaryAction={backdropAlert.secondaryAction}
    />
    </>
  );
}